Platform.Deferred.execute(setViewDetailsScript);
var canBeGiftWrapped = "@Model.data.CanBeGiftWrapped";
function setViewDetailsScript() {    
    //handle selecting variants from dropdown
    showSelectedVariant()
    $('#variant-select').on('change', function () {
        showSelectedVariant()
    });
    function showSelectedVariant()
    {
        $(".variantRow").hide(50,function ()
        {
            $(".current").removeClass("current");
            var selected = $("#variant-select").find(":selected");
            var selectedID = $(selected).val();
            var selectorString = "#variant-row-" + selectedID;
            $(selectorString).show(50);
            $(selectorString).addClass("current");
        });
    }
    $('.productwrapper').matchHeight();

    $('#other-products-tabs a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    })

    $('#product-media-holder').lightGallery({
        selector: '.product-media',
        loadYoutubeThumbnail: false,
        loadVimeoThumbnail: false
    });

    $('#product-media-holder-2').lightGallery({
        selector: '.mobile-vid',
        loadYoutubeThumbnail: false,
        loadVimeoThumbnail: false
    });

    $('.add-btn').click(function () {
        var fbPixelEnabled = $('#product-view-container').data("fb-pixel");
        var btn = $(this);
        var id = btn.data("id");
        var prodOptsOk = true;
        $('.productOptions').each(function () {
            if ($(this).length > 0) {
                if ($(this).val() == 0) {
                    $(this).next('.productOptionWarn').fadeIn();
                    $(this).addClass("highlight");
                    prodOptsOk = false;
                    return false;
                }
            }
        });

        if (prodOptsOk == false) {
            return false;
        }

        var opts = [];
        $('.productOptions').each(function (i, o) {
            var opt = {}
            var name = $(this).attr('id');
            name = name.replace("option-select-", "");
            opt.index = i;
            opt.name = name;
            opt.value = $(this).val();
            opts.push(opt);
        });

        
        var parentID = $('#parent-id').val();
        var catID = $('#cat-id').val();
        var listby = $('#listby').val();
        var size = $('#size-select').val();

        // gift option and message
        var useGiftBox = false;
        if (canBeGiftWrapped == "True") {
            $('#giftBoxingCbx').prop('checked');
            useGiftBox = true;
        }
        if (useGiftBox) {
            var personalMessage = $('#giftBoxText').val();
        }

        var variantId = $(btn).data("variant-id");
        var qty = 0;
        if (variantId != 0) {
            var qty = $(this).closest(".variant-table").find('.qty-tbx').val();
        }
        else {
            var qty = $(this).closest("#add-to-bag").find('.qty-tbx').val();
        }

        $.ajax({
            url: root + "Cart/AddToCart",
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                productId: id,
                quantity: qty,
                options: opts,
                variantId: variantId === 0 ? null : variantId
            }),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                AddedToCart(data);
                SetCartQty();
                if (fbPixelEnabled == "True") {
                    fbq_addToBag();
                }
            }
        });

        return false;
    });

    $('#size-select').change(function () {
        $('#choose-size-warn').fadeOut();
    });

    $('.productOptions').change(function () {
        $(this).removeClass('highlight');
        $(this).next('.productOptionWarn').fadeOut();
    });

    // favourites handlers
    $('.add-to-favorites-btn').click(function () {
        var loggedIn = $('#product-view-container').data("logged-in");
        if (loggedIn == "True") {

            var btn = $(this);
            var isVariant = btn.data("is-variant");
            var wrapper = $(this).closest('.fav-btns');
            var id = btn.data("id");
            var title = btn.data("title");
            var isFav = btn.data("is-fav");
            if (isFav == "False") {

                // if any options make sure all have a selection made
                var prodOptsOk = true;
                $('.productOptions').each(function () {
                    if ($(this).length > 0) {
                        if ($(this).val() == 0) {
                            $(this).next('.productOptionWarn').fadeIn();
                            $(this).addClass("highlight");
                            prodOptsOk = false;
                            return false;
                        }
                    }
                });

                if (prodOptsOk == false) {
                    return false;
                }

                var opts = [];
                $('.productOptions').each(function (i, o) {
                    var opt = {}
                    var name = $(this).attr('id');
                    name = name.replace("option-select-", "");
                    opt.index = i;
                    opt.name = name;
                    opt.value = $(this).val();
                    opts.push(opt);
                });

                $.post(root + "UserAccount/AddProductToFavourites", { id: id, isVariant: isVariant, options: opts }, function (data) {
                    if (data.result == "ok") {
                        //toastr["success"]("'" + title + "'" + " added to your favourites.")
                        wrapper.find('.isfav-icon').show();
                        wrapper.find('.isnotfav-icon').hide();
                    }
                    else {
                        alert("Error: " + data.error);
                    }
                }, "json");
            }
            else {
                $.post(root + "UserAccount/RemoveProductFromFavourites", { id: id, isVariant: isVariant }, function (data) {
                    if (data.result == "ok") {
                        //toastr["warning"]("'" + title + "'" + " removed from your favourites.")
                        wrapper.find('.isfav-icon').hide();
                        wrapper.find('.isnotfav-icon').show();
                    }
                    else {
                        alert("Error: " + data.error);
                    }
                }, "json");
            }
        }
        else {
            loginModal.open();
        }
    });

}

function AddedToCart(data) {
    if (data.result == "ok") {
        GetAndOpenTopCart();
        $("html, body").animate({ scrollTop: 0 }, "slow"); // scroll to top
    }
    if (data.result == "ok-stock-limited") {
        alert("Sorry there are only " + data.qty + " of these items available in stock.");
        GetAndOpenTopCart();
        $("html, body").animate({ scrollTop: 0 }, "slow"); // scroll to top
    }
    if (data.result == "ok-out-of-stock") {
        alert("Sorry this item is no longer in stock.");
        GetTopCart();
    }
}

function vidClosed() {
    jQuery("#youtubePlayerContainer").tubeplayer("stop");
}
